import {
  ClockIcon,
  ExpandIcon,
  ExpandLess,
  OnHoldIcon,
  SentBackIcon,
  SkippedIcon,
  TickIcon
} from "@/features/common/Icons";
import { Step } from "../ReviewsInProgress";
import { stepClass } from "./WorkflowTaskStep";
import { WorkflowTaskStepTooltip } from "./WorkflowTaskStepTooltip";
import { TooltipData } from "./WorkflowTaskProgress";
import {
  ENTER,
  IN_PROGRESS_STATUS,
  NOT_STARTED_STATUS,
  ON_HOLD_STATUS,
  SENT_BACK_STATUS,
  SKIPPED_STATUS,
  SUBMITTED_STATUS,
  TAB
} from "@/features/common/constants";

interface WorkflowTaskSmallScreenProps {
  step: Step;
  showStepIndex: number;
  tooltipData: TooltipData | null;
  showTooltipSmallScreen: boolean;
  openTooltip: (stepIndex: number) => void;
}

export function WorkflowTaskStepSmallScreen({
  step,
  showStepIndex,
  tooltipData,
  openTooltip
}: WorkflowTaskSmallScreenProps) {
  function handleKeyPress(event: React.KeyboardEvent, stepIndex: number) {
    if (event.key === ENTER) {
      openTooltip(stepIndex);
    } else if (event.key === TAB && step.stepIndex === showStepIndex) {
      openTooltip(stepIndex);
    }
  }
  return (
    <>
      <div
        onClick={() => openTooltip(step.stepIndex)}
        className={
          step.stepIndex === showStepIndex
            ? `step-small-screen tabbing ${stepClass(
                step.state
              )} expand-details`
            : `step-small-screen hover tabbing ${stepClass(step.state)}`
        }
        onKeyDown={(event) => handleKeyPress(event, step.stepIndex)}
        tabIndex={0}
      >
        <div className="step-content">
          {step.state === NOT_STARTED_STATUS ? (
            step.name
          ) : (
            <div className="flex-row in-progress-content">
              <div className="clock-icon">
                {step.state === IN_PROGRESS_STATUS && <ClockIcon />}
                {step.state === SUBMITTED_STATUS && <TickIcon />}
                {step.state === SENT_BACK_STATUS && (
                  <div className="sent-back">
                    <SentBackIcon />
                  </div>
                )}
                {step.state === SKIPPED_STATUS && (
                  <div className="skipped">
                    <SkippedIcon />
                  </div>
                )}
                {step.state === ON_HOLD_STATUS && (
                  <div className="on-hold">
                    <OnHoldIcon />
                  </div>
                )}
              </div>
              <div className="step-name">{step.name}</div>
            </div>
          )}
        </div>
        {step.stepIndex !== showStepIndex ? (
          <div>
            <ExpandIcon />
          </div>
        ) : (
          <div>
            <ExpandLess />
          </div>
        )}
      </div>
      {step.stepIndex === showStepIndex && tooltipData && (
        <WorkflowTaskStepTooltip tooltipData={tooltipData} />
      )}
    </>
  );
}
